import { render, staticRenderFns } from "./IconNav.vue?vue&type=template&id=3f2a9920&scoped=true&"
import script from "./IconNav.vue?vue&type=script&lang=js&"
export * from "./IconNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2a9920",
  null
  
)

export default component.exports